import { DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';
import { asLabel } from '@shure/shared/angular/utils/i18n';

export function mapDeviceStatusToTranslocoKey(deviceStatus: DeviceStatus | undefined): string {
	switch (deviceStatus) {
		case DeviceStatus.Online:
			return asLabel('shAgGrid.common.network.online');
		case DeviceStatus.Offline:
			return asLabel('shAgGrid.common.network.offline');
		case DeviceStatus.Error:
			return asLabel('shAgGrid.common.network.error');
		case DeviceStatus.Discovered:
			return asLabel('shAgGrid.common.network.discovering');
		case undefined:
			return '';
	}
}
